/**
 * @fileoverview Configuración del módulo API Munzen
 * @author Omar Sánchez Martinez
 * @since 15/10/2025
 */

import type { ApiConfig } from '../types';

/**
 * Valida y obtiene la URL base del API desde variables de entorno
 * @throws {Error} Si VITE_MUNZEN_API_URL no está configurada
 * @returns URL base del API
 */
const getBaseURL = (): string => {
  const baseURL = import.meta.env.VITE_MUNZEN_API_URL;

  if (!baseURL) {
    throw new Error(
      '❌ VITE_MUNZEN_API_URL no está configurada.\n' +
        'Por favor, verifica tu archivo .env y asegúrate de que la variable esté definida.\n' +
        'Ejemplo: VITE_MUNZEN_API_URL=https://api.munzen.com',
    );
  }

  return baseURL as string;
};

/**
 * Timeout por defecto para peticiones HTTP (60 segundos)
 */
export const API_TIMEOUT = 60_000;

/**
 * Buffer de tiempo en milisegundos antes de la expiración del token
 * para iniciar el refresh preventivo (60 segundos)
 */
export const REFRESH_BUFFER_MS = 60_000;

/**
 * Número máximo de reintentos para operaciones de refresh token
 */
export const MAX_RETRIES = 2;

/**
 * Timeout máximo para operaciones de refresh token (30 segundos)
 */
export const REFRESH_TIMEOUT_MS = 30_000;

/**
 * Configuración por defecto para la instancia de axios
 */
export const apiConfig: ApiConfig = {
  baseURL: getBaseURL(),
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 * Configuración para desarrollo (puede incluir logging adicional)
 */
export const isDevelopment = import.meta.env.DEV;

/**
 * Configuración para producción
 */
export const isProduction = import.meta.env.PROD;
